import script from "./SearchManagementView.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchManagementView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__